import React, { useContext } from "react";
import { Suspense,  useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import Callback from "../Auth/Callback";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";

import AuthContext from "../_helper/auth";

const Routers = () => {
  const [currentUser, setCurrentUser] = useState(false);

  const { authenticated,setAuthenticated}=useContext(AuthContext)
  // useEffect(() => {
  //   let abortController = new AbortController();
  //   setAuthenticated(localAuth);
  //   console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
  //   console.disableYellowBox = true;
  //   return () => {
  //     abortController.abort();
  //   };
  // }, []);

  return (
    <BrowserRouter basename={"/"}>
      <>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route
              path={"/"}
              element={<PrivateRoute authenticated={authenticated} />}
            >
              {currentUser !== null || authenticated ? (
                <>
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}`}
                    element={<Navigate to={`${process.env.PUBLIC_URL}/home`} />}
                  />
                  <Route
                    exact
                    path={`/`}
                    element={<Navigate to={`${process.env.PUBLIC_URL}/home`} />}
                  />
                </>
              ) : (
                ""
              )}
              <Route path={`/*`} element={<LayoutRoutes />} />
            
            </Route>
            <Route
              path={`${process.env.PUBLIC_URL}/callback`}
              element={ <Callback />}
            />
            <Route  
              exact
              path={`${process.env.PUBLIC_URL}/system_administrator/verify`}
              element={
                <Signin
                  authenticated={authenticated}
                  setAuthenticated={setAuthenticated}
                  setCurrentUser={setCurrentUser}
                />
              }
            />
      
            {authRoutes.map(({ path, Component }, i) => (
              <Route path={path} element={Component} key={i} />
            ))}
          </Routes>
        </Suspense>
      </>
    </BrowserRouter>
  );
};

export default Routers;
